var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5574_195)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 44,
    rx: 18,
    fill: "#25282D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2656 27L33 12L16.1859 17.0473C15.9122 17.1266 15.6635 17.2773 15.4646 17.4846C15.2657 17.6918 15.1236 17.9484 15.0522 18.2289C14.9808 18.5093 14.9827 18.8039 15.0577 19.0834C15.1327 19.3629 15.2782 19.6175 15.4797 19.8221L18.2656 22.6553V27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 28.7211H23.7463L26.2234 31.5219C26.3565 31.6734 26.5148 31.7937 26.6891 31.8757C26.8634 31.9578 27.0503 32 27.2391 32C27.3633 31.9998 27.487 31.9818 27.6073 31.9466C27.8503 31.8772 28.0728 31.7365 28.2525 31.5387C28.4322 31.3409 28.5627 31.093 28.6308 30.8199L33 14L20 28.7211Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5574_195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 44,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.0ed3031d1b299a2c50debb3e6c0ff415.svg";
export { ForwardRef as ReactComponent };